module.exports = __webpack_public_path__ + "media/img/powered-ociobusiness-c92bc0f572bd1dde8ebde8290563331f.png";